export const SITE_SUBFOLDER = 'site/';

export const getStaticPath = () => process.env.DEVELOPMENT ? '../' : './';

 export const getGraphQLPath = (path) => process.env.DEVELOPMENT ? path.replace(SITE_SUBFOLDER, '')  : '..' + path;


export const getGraphQLPathGallery = (path) => process.env.DEVELOPMENT ? path.replace(SITE_SUBFOLDER, '')  : '../..' + path;
// export const getGraphQLPath = (path) => process.env.DEVELOPMENT ? path.replace(SITE_SUBFOLDER, '')  :  path;
